export default function handlePagination(response, oldState, _resultsKey) {
  const resultsKey = _resultsKey || "results"
  let results = {}

  if (response.page === 0) {
    response.pages = [response.results]
    delete response.results
    results = { ...response }
  } else {
    const pagesCopy = JSON.parse(JSON.stringify(oldState[resultsKey].pages))

    pagesCopy[response.page] = response.results
    results = { ...oldState[resultsKey] }
    results.pages = pagesCopy
    results.nextPage = response.nextPage
  }
  return results
}
